import * as Sentry from '@sentry/react';
import { SentryReduxState } from 'app/redux/sentryReduxSetup';
import { sentryErrorHandledProperty } from 'common/api/utils/handleError';
import { environment } from 'environment';
import { Constants } from 'utils/constants';

const replay = new Sentry.Replay({ maskAllText: false });

const enrichSentryEvent = (e: Sentry.Event): Sentry.Event => {
  // Determine if our error handler dealt with the error.
  const handled = e.contexts && e.contexts[sentryErrorHandledProperty];

  if (!handled && e.event_id) {
    Sentry.showReportDialog({ eventId: e.event_id });
  }

  const reduxState = e.contexts?.state?.state?.value;
  const userState = reduxState && (reduxState as SentryReduxState).user;

  // Attach redux user data for enhanced tracking in Sentry's UI context.
  e.user = userState || undefined;

  return e;
};

export const sentryConfig: Sentry.BrowserOptions = {
  dsn: 'https://eb5d615d9b3e3d5a1262b21844d2fcd7@o4506621406412800.ingest.sentry.io/4506625051000832',
  environment: environment.name,
  release: Constants.release,
  normalizeDepth: 5, // Replace default (3) to see redux state in Sentry UI.
  integrations: [replay],
  replaysOnErrorSampleRate: 1.0,
  beforeSend(e) {
    if (process.env.NODE_ENV === 'production') {
      return enrichSentryEvent(e);
    }
    return null;
  },
};
